// extracted by mini-css-extract-plugin
export default {"page__title":"second_page__title__0Yt7P","form":"second_form__JmdGm","form__fields":"second_form__fields__y6t1c","form__button":"second_form__button__1lpK0"};